export default __webpack_public_path__ + "static/media/hero.ce9a4572.jpg";